import { allSpecSheetTabs, SpecSheetTab } from "@specsheet-common/shared-types";

/**
 * Empty channel arrays are truthy in JS and must not be persisted as
 * `{ categories: [] }` — that hides the column from every tab.
 */
export const getNonEmptySpecSheetTabs = (
  channels: SpecSheetTab[] | null | undefined
): SpecSheetTab[] | undefined => {
  if (!Array.isArray(channels) || channels.length === 0) {
    return undefined;
  }
  return channels;
};

/**
 * Only return channel lists that restrict tabs. A full-tab list means "all tabs"
 * and should stay `undefined` on the campaign view model.
 */
export const getRestrictedSpecSheetTabs = (
  categories: SpecSheetTab[] | null | undefined
): SpecSheetTab[] | undefined => {
  const channels = getNonEmptySpecSheetTabs(categories);
  if (!channels) {
    return undefined;
  }

  const restrictsTabs = !allSpecSheetTabs.every((tab) =>
    channels.includes(tab)
  );
  return restrictsTabs ? channels : undefined;
};
